import { Link } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function BreadcrumbCrumb({ item, index }) {
    const { breadcrumbs, setCategoryId, setSelectedTaskId, selectedTaskId } = useBoundContext()
    const isLast = index === breadcrumbs.length - 1
    const isTaskCrumb = item.id === selectedTaskId || (selectedTaskId === "new" && item.id === "new")

    return (
        <Link
            variant="body2"
            underline={isLast ? "none" : "hover"}
            color={isLast ? "text.primary" : "inherit"}
            onClick={handleClick}
            sx={{
                cursor: isLast ? "default" : "pointer",
                display: "inline-flex",
                alignItems: "center",
                fontWeight: isLast ? "bold" : "normal",
                lineHeight: 1,
            }}
        >
            {item.isHome && <Iconify icon="eva:home-fill" sx={{ mr: 0.5, width: 16, height: 16, flexShrink: 0 }} />}
            {item.name}
        </Link>
    )

    function handleClick() {
        if (isLast) return
        if (isTaskCrumb) return

        // If clicking a category crumb while a task is selected, it should clear the task
        setSelectedTaskId(null)
        setCategoryId(item.id)
    }
}
